// Packages
import React, { useEffect } from "react";
import { connect } from "react-redux";
// Components
import Header from "../../components/header";
import TosSingapore from "./tosSingapore";
import TosGeneral from "./tosGeneral";
// Redux Operations
import { pageOperations } from "../../state/features/page";

interface ITermsOfServiceProps {
  company: any;
  paymentTypes: any;
  fetchTermsOfServiceConfigurations: any;
}

function TermsOfService(props: ITermsOfServiceProps) {
  useEffect(() => {
    props.fetchTermsOfServiceConfigurations();
  }, []);

  return (
    <>
      <Header />
      {props.company.country_code === 'SG' ? (
        <TosSingapore company={props.company} />
      ) : (
        <TosGeneral
          company={props.company}
          paymentTypes={props.paymentTypes}
        />
      )}
    </>
  );
}

const mapStateToProps = (state: any) => {
  let company = state.company || {};
  let paymentTypes = state.paymentTypes || [];

  return {
    company,
    paymentTypes,
  };
};

const mapDispatchToProps = {
  fetchTermsOfServiceConfigurations: pageOperations.fetchTermsOfServiceConfigurations,
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsOfService);
